import simpleModal from './simple_modal';

export default {
  simpleModal,
};
